// Preact 버전의 icon — JSX 안에서 inline SVG로 쓰려고 만든 동등 컴포넌트.
// 기존 dom.ts의 icon()은 SVGSVGElement를 반환하므로 JSX 트리에 그대로 끼울 수 없음.

import { ICON_PATHS } from "../dom";

interface IconProps {
  name: string;
  size?: number;
  strokeWidth?: number;
}

export function Icon({ name, size = 20, strokeWidth = 2 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width={strokeWidth}
      stroke-linecap="round"
      stroke-linejoin="round"
      dangerouslySetInnerHTML={{ __html: ICON_PATHS[name] || "" }}
    />
  );
}
